import xml2js from 'xml2js';
import { v4 as uuidv4 } from 'uuid';

const groupBy = (key) => (array) =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key] || 'default';
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

const xmlToObject = (xml) => {
  return xml2js.parseStringPromise(xml);
};

const clonePolyline = (gmaps, source) => {
  const polyline = new gmaps.google.maps.Polyline({
    strokeOpacity: 1.0,
    strokeWeight: 3,
    map: source.getMap(),
    editable: source.getEditable(),
    draggable: source.getDraggable()
  });

  polyline.setPath([...source.getPath().getArray()]);
  polyline.id = source.id;

  return polyline;
};

const destroyPolyline = (polyline, { removeListeners = true } = {}) => {
  polyline.setMap(null);
  polyline.setEditable(false);
  polyline.setDraggable(false);
  if (removeListeners) {
    polyline.addPointListener && polyline.addPointListener.remove();
    polyline.updateLineListener && polyline.updateLineListener.remove();
    polyline.removePointListener && polyline.removePointListener.remove();
  }

  return null;
};

const createPolyline = (gmaps, options = {}, source) => {
  const polyline = new gmaps.google.maps.Polyline({
    strokeOpacity: 1.0,
    strokeWeight: 3,
    map: gmaps.map,
    ...options
  });

  if (source) {
    polyline.setPath([...source.getPath().getArray()]);
  }

  polyline.id = uuidv4();

  return polyline;
};

export { groupBy, xmlToObject, createPolyline, destroyPolyline, clonePolyline };
